import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ConfigProvider } from "../../../../config-provider.service";
import { NgIf } from "@angular/common";
import { MatCard } from "@angular/material/card";
import { AuthFormComponent } from "../auth-form/auth-form";
import { translateFadeBeforeAfterAnimation } from "../../../animations/translate-fade-before-after";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CurrentUser } from "../../../providers/current-user";
import { UtilsProvider } from "../../../providers/utils-provider.service";
import { AuthDialogComponent } from "../auth-dialog/auth-dialog";
import { FullScreenLoaderComponent } from "../../full-screen-loader/full-screen-loader";

@Component({
  selector: 'auth',
  providers: [
  ],
  styleUrls: ['./auth.scss'],
  templateUrl: './auth.html',
  standalone: true,
  imports: [
    NgIf,
    MatCard,
    AuthFormComponent,
    FullScreenLoaderComponent
  ],
  animations: [translateFadeBeforeAfterAnimation]
})
export class AuthComponent implements AfterViewInit, OnDestroy {
    @Input() public image = '';
    @Input() public title = '';
    @Input() public nextUrl?: string = undefined;
    @Input() public defaultNextUrl?: string = undefined;
    @Input() public detectPasswordResets = false;
    @Input() public isRegistrationDisabled = false;
    @Input() public isModal = true;


    private subscriptions: Subscription[] = [];
    constructor(
        public conf: ConfigProvider,
        public utils: UtilsProvider,
        public currentUser: CurrentUser,
        private _route: ActivatedRoute,
        private _dialoger: MatDialog,
        private _changeDetector: ChangeDetectorRef
    ) {
    }

    public ngAfterViewInit() {
        if (this.detectPasswordResets) {
            this.subscriptions.push(
                this._route.queryParamMap.subscribe((params) => {
                  // c'est que l'utilisateur a cliqué sur un lien de renouvellement du mot de passe
                  // on affiche donc le dialog qui va permettre de mettre à jour son mot de passe
                  if (params.has('authEmail') && params.has('authToken')) {
                      // on met ça dans un timeout pour éviter un bug d'initialisation de la popup
                      // (bug lié à la librairie material donc ...)
                      setTimeout(() => { this.onClicked(); }, 1);
                  }
                })
            );
        } else {
        }
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public onClicked(): void {
        const dialog: MatDialogRef<AuthDialogComponent> = this._dialoger.open(AuthDialogComponent, {
            data: {
                title: this.title,
                image: this.image,
                nextUrl: this.nextUrl,
                defaultNextUrl: this.defaultNextUrl,
                isRegistrationDisabled: this.isRegistrationDisabled
            }
        });
    }
}
